import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
  emailTimingTypes: [],
  emailOnTypes: [],
  timeoutTypes: [],
  deliveryChaseTypes: [],
  clientDeliveryRules: [],
  emailTimings: {}
};

const getters = {
  getEmailTimingTypes: (state) => state.emailTimingTypes,
  getEmailOnTypes: (state) => state.emailOnTypes,
  getTimeoutTypes: (state) => state.timeoutTypes,
  getDeliveryChaseTypes: (state) => state.deliveryChaseTypes,
  getClientDeliveryRules: (state) => state.clientDeliveryRules,
  getEmailTimings: (state) => state.emailTimings
};

const actions = {
  async getEmailTimingTypes( context, data ) {
    await axios.get(`${backendUrl()}/getEmailTimingTypes`,
    {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setEmailTimingTypes', response.data)
    })
  },
  async getEmailOnTypes( context, data ) {
    await axios.get(`${backendUrl()}/getEmailOnTypes`,
    {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setEmailOnTypes', response.data)
    })
  },
  async getTimeoutTypes( context, data ) {
    await axios.get(`${backendUrl()}/getTimeoutTypes`,
    {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setTimeoutTypes', response.data)
    })
  },
  async getDeliveryChaseTypes( context, data ) {
    await axios.get(`${backendUrl()}/getDeliveryChaseTypes`,
    {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setDeliveryChaseTypes', response.data)
    })
  },
  async getClientDeliveryRules( context, data ) {
    await axios.get(`${backendUrl()}/getClientDeliveryRules`,
    {
        headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
    })
    .then(response => {
        context.commit('setClientDeliveryRules', response.data)
    })
  },
  async applyClientDeliveryRule(context, data) {
      await axios.post(`${backendUrl()}/applyClientDeliveryRule`,data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.dispatch('handleResponse', response, {root: true})
      })
  }
};

const mutations = {
  setEmailTimingTypes: (state, emailTimingTypes) => (state.emailTimingTypes = emailTimingTypes),
  setEmailOnTypes: (state, emailOnTypes) => (state.emailOnTypes = emailOnTypes),
  setTimeoutTypes: (state, timeoutTypes) => (state.timeoutTypes = timeoutTypes),
  setDeliveryChaseTypes: (state, deliveryChaseTypes) => (state.deliveryChaseTypes = deliveryChaseTypes),
  setClientDeliveryRules: (state, clientDeliveryRules) => (state.clientDeliveryRules = clientDeliveryRules),
  setEmailTimings: (state, emailTimings) => (state.emailTimings = emailTimings)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
